/*
  Custom class for API errors.
  See also: https://stackoverflow.com/questions/41102060/typescript-extending-error-class
*/

/**
 * From https://grpc.github.io/grpc/core/md_doc_statuscodes.html
 */
enum GRPC_ERROR_CODES {
  OK,
  CANCELLED,
  UNKNOWN,
  INVALID_ARGUMENT,
  DEADLINE_EXCEEDED,
  NOT_FOUND,
  ALREADY_EXISTS,
  PERMISSION_DENIED,
  RESOURCE_EXHAUSTED,
  FAILED_PRECONDITION,
  ABORTED,
  OUT_OF_RANGE,
  UNIMPLEMENTED,
  INTERNAL,
  UNAVAILABLE,
  DATA_LOSS,
  UNAUTHENTICATED,
}

export class APIError extends Error {
  reason?: string;
  status?: number;
  details?: any;
  grpcCode?: GRPC_ERROR_CODES;

  constructor(
    message?: string,
    reason?: string,
    status?: number,
    details?: any,
    code: string = "2"
  ) {
    // 'Error' breaks prototype chain here
    super(message);

    // restore prototype chain
    const actualProto = new.target.prototype;
    this.reason = reason;
    this.status = status;
    this.details = details;
    this.grpcCode = parseInt(code);

    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(this, actualProto);
    } else {
      // @ts-ignore
      this.__proto__ = actualProto;
    }
  }
}

/** Error used to identify cancelled network requests */
export class CancelledError extends Error {}
